<template>
  <l-input
    v-model="model"
    name="gpa"
    class="field:max-w-2xs"
    size="sm"
    type="number"
    label="GPA"
    min="0"
    max="4.33"
    step="0.01"
    pattern="[0-9]\.[0-9]{2}"
    placeholder="0-4.33"
  >
    <template #help>
      Your
      LSAC CAS GPA
      <term
        href="https://www.lsac.org/applying-law-school/jd-application-process/cas/requesting/transcript-summarization"
        name="casGpa"
      />
    </template>
  </l-input>
</template>

<script setup>
import LInput from "@/components/inputs/LInput.vue"
import Term from "@/components/Term.vue"

const model = defineModel([String, Number])
</script>
